import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'

// Global base + single terse design-system vocabulary
import '@/assets/styles/base.css'
import '@/assets/styles/tokens.css'
import '@/assets/styles/primitives.css'
import '@/assets/styles/login.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.mount('#app')
